var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"with-padding",style:({flex: 1, justifyContent: 'right'})},[_vm._v(" "+_vm._s(_vm.value)+" "),(_vm.suffix)?_c('span',[_vm._v(" "+_vm._s(_vm.suffix))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }